/**
 * SIMS-8948 — prepaid cards (PPC) message.
 *
 * PPC is an in-development incentive type that was never finished or tested.
 * Its admin surfaces used to call backend-1 endpoints; those calls are gone so
 * backend-1 can be decommissioned (epic SIMS-6473). The `incentiveType === "PPC"`
 * conditionals, the domain types and the enum all remain — the concept exists,
 * it simply has no working implementation behind it.
 *
 * If PPC is picked up again it will be rebuilt on backend-2, so this message is
 * the honest state rather than a placeholder for a route that still works.
 *
 * One exported constant so a wording change lands everywhere at once, the same
 * reason MULTI_TREATMENT_PLAN_LABEL is shared in the SIMS-6472 work.
 */
export const PREPAID_CARDS_NOT_IMPLEMENTED =
	"Prepaid card management is not implemented yet.";
